/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_PrepInputs */

const en_plan_prep = /** @type {(inputs: Plan_PrepInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prep ahead`)
};

const de_plan_prep = /** @type {(inputs: Plan_PrepInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vorbereiten`)
};

/**
* | output |
* | --- |
* | "Prep ahead" |
*
* @param {Plan_PrepInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const plan_prep = /** @type {((inputs?: Plan_PrepInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_PrepInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_plan_prep(inputs)
	return en_plan_prep(inputs)
});